/* eslint-disable no-new */
import Vue from 'vue';
import camelCase from './camelcase';

Vue.config.productionTip = false;

const addComponent = (availableComponents, componentName, el, props, store) => {
  const cmp = availableComponents[componentName];
  if (!cmp) {
    console.log('missing component', componentName); // eslint-disable-line
    return;
  }
  const data = Object.assign({}, props);
  window.vue = new Vue({
    el,
    data,
    store,
    render: createElement => createElement(cmp, { attrs: data }),
  });
};

const loader = (availableComponents, store) => {
  const componentList = document.querySelectorAll('[data-component]');
  Array.prototype.slice.call(componentList).forEach((elm) => {
    // Collect element data attributes
    const elmData = {};
    Array.prototype.slice.call(elm.attributes)
      .filter(attr => attr.name.indexOf('data-') === 0)
      .forEach((attr) => {
        const name = camelCase(attr.name.split('data-').pop());

        let value = attr.value
        if (name === 'component') {
          // forgive component names not starting with a capital letter
          value = `${attr.value[0].toUpperCase()}${attr.value.slice(1)}`
        } else {
          try {
            value = JSON.parse(value)
          } catch (e) {
            // do nothing
          }
        }

        elmData[name] = value;
      });
    // Create Vue app
    addComponent(availableComponents, elmData.component, elm, elmData, store);
  });
};

export { loader as default, addComponent };
